import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatContentType(type: string): string {
  // Convert camelCase to "Title Case" and replace common abbreviations
  return type
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
    .replace(/listing/g, '') // Remove "listing"
    .trim();
}

// Re-export color utilities from centralized location
export { getBgColorClass } from "./colors";